import _ from 'lodash'
import classNames from 'classnames'
import propTypes from 'prop-types'


export default function Select(props) {
  return (
    <select
      {...props.selectProps}
      className={classNames([
        'border-none outline-none focus:outline-none focus:ring-0',
        props.className,
      ])}
      onChange={props.onChange}
    >
      {
        _.map(
          props.options,
          option => (
            <option
              key={`select_${option.value}`}
              value={option.value}
            >
              {option.label}
            </option>
          )
        )
      }
    </select>
  )
}


Select.propTypes = {
  className: propTypes.string,
  options: propTypes.arrayOf(propTypes.shape({
    label: propTypes.any.isRequired,
    value: propTypes.string.isRequired,
  })),
  onChange: propTypes.func,
}
